package anjuros.development.modules

import anjuros.development.components.language.ResKey
import anjuros.development.util.Res

enum class Room(
    var image:String,
    var title:ResKey,
    var desc: ResKey,
    var zoomImages: List<String>
){

    ROOM1(
        image = Res.Image.room_twin,
        title = ResKey.ROOM1,
        desc = ResKey.ROOM1_DESC,
        zoomImages = listOf(
            Res.Image.room1_1,
            Res.Image.room1_2,
            Res.Image.room1_3,
            Res.Image.room1_4,
            Res.Image.room1_5
        )
    ),
    ROOM2(
        image = Res.Image.room_triple,
        title = ResKey.ROOM2,
        desc = ResKey.ROOM2_DESC,
        zoomImages = listOf(
            Res.Image.room2_1,
            Res.Image.room2_2,
            Res.Image.room2_3,
            Res.Image.room2_4,
            Res.Image.room2_5
        )
    ),
    ROOM3(
        image = Res.Image.room_quardiple,
        title = ResKey.ROOM3,
        desc = ResKey.ROOM3_DESC,
        zoomImages = listOf(
            Res.Image.room3_1,
            Res.Image.room3_2,
            Res.Image.room3_3,
            Res.Image.room3_4,
            Res.Image.room3_5
        )
    ),

}

